import { fulfillmentStatuses } from '../../constants';
import { FAMILIES_NOT_REQUIRING_PAYMENT } from '../../constants/payment';
import type { ProductFamily } from '../../constants/products';
import matchDate from '../matchDate';

export type Entitlements = {
  family: ProductFamily;
  defermentInfo?: unknown;
  fulfillmentStatus?: string;
  plans?: Array<{
    nextBillDate?: string | null;
  }>;
};

type SwitchInfoResult = {
  billingDateToday: boolean;
  switchPermitted: boolean;
};

const nonPaymentFamilies: readonly ProductFamily[] = FAMILIES_NOT_REQUIRING_PAYMENT;

const switchInfo = (entitlements: Entitlements): SwitchInfoResult => {
  const nextBillingDate = entitlements.plans?.[0]?.nextBillDate ?? null;

  const billingDateToday = !nonPaymentFamilies.includes(entitlements.family) && matchDate(nextBillingDate);
  const { defermentInfo, fulfillmentStatus } = entitlements;
  const switchPermitted = !defermentInfo && !billingDateToday && fulfillmentStatus === fulfillmentStatuses.succeeded;
  const result = {
    billingDateToday,
    switchPermitted,
  };
  return result;
};

export default switchInfo;
